<template>
<div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "CloudHome",
  data() {
    return {};
  },
  created() {
    this.setIsPcMode();
  },
  mounted() {},
  methods: {
    ...mapActions(["setIsPcMode"]),
  },
  computed: {},
};
</script>

<style lang="scss">
body {
  margin: 0;
  padding: 0;
}

#app {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
}
</style>
